import L from 'leaflet';
import { OPEN_WEATHER_MAP_KEY } from '@/config';
import { displayDateTime } from '@/helpers/time';
export default L.Layer.extend({
    options: {
        op: 'PA0',
        anchorTime: Date.now(),
        intervals: 4,
        intervalGap: 3 * 60 * 60,
        updateTime: 2000, // 2 seconds
    },
    initialize: function (options) {
        L.Util.setOptions(this, options);
        this.map = null;
        this.weatherLayers = [];
        this.updateInterval = null;
    },
    convertDateObjectToUnix: function (date) {
        if (!date)
            return Date.now() / 1000;
        const time = date.getTime();
        return time / 1000;
    },
    getWeatherLayers: function () {
        const url = 'https://maps.openweathermap.org/maps/2.0/weather/{op}/{z}/{x}/{y}?appid={apiKey}&date={date}';
        const layers = [];
        const { op, anchorTime, intervals, intervalGap, } = this.options;
        // Round time to nearest 5 mins
        const coeff = 1000 * 60 * 5;
        const dateObj = new Date(anchorTime);
        const rounded = new Date(Math.round(dateObj.getTime() / coeff) * coeff);
        const unixDate = this.convertDateObjectToUnix(rounded);
        for (let i = 0; i < intervals; i += 1) {
            const date = Math.ceil(unixDate + (i * intervalGap));
            const options = {
                op,
                apiKey: OPEN_WEATHER_MAP_KEY,
                date,
                opacity: 0,
            };
            layers.push(L.tileLayer(url, options));
        }
        return layers;
    },
    cycleLayers: function () {
        const { cycleIndex } = this;
        const count = this.weatherLayers.length;
        const next = cycleIndex + 1 < count ? cycleIndex + 1 : 0;
        this.weatherLayers[cycleIndex].setOpacity(0);
        this.weatherLayers[next].setOpacity(1).bringToFront();
        this.cycleIndex = next;
        this.updateTimeText();
    },
    updateTimeText: function () {
        const currentLayer = this.weatherLayers[this.cycleIndex];
        // The options object on the currentLayer is dynamic and not ts-friendly
        // @ts-ignore
        const date = displayDateTime(currentLayer.options.date * 1000);
        this.timeText.innerHTML = `<span>Weather at ${date}</span>`;
    },
    onAdd: function (map) {
        this.map = map;
        this.weatherLayers = this.getWeatherLayers();
        this.weatherLayers.forEach((layer) => {
            if (this.map === null)
                return;
            layer.addTo(this.map);
        });
        this.timeText = L.DomUtil.create('div', 'leaflet-time-info', map.getContainer());
        this.cycleIndex = 0;
        this.weatherLayers[0]?.setOpacity(1);
        this.updateInterval = window.setInterval(this.cycleLayers.bind(this), this.options.updateTime);
        return this;
    },
    onRemove: function (map) {
        this.weatherLayers.forEach((layer) => {
            map.removeLayer(layer);
        });
        L.DomUtil.remove(this.timeText);
        if (this.updateInterval) {
            window.clearInterval(this.updateInterval);
        }
    },
});
